export const productDict = {
    OptiSuiteC: "https://www.ivldsp.com/products/optisuitec-2-0/",
    OptiSuite: "https://www.ivldsp.com/products/optisuite/",
    OptiExim: "https://www.ivldsp.com/products/optisuitec-2-0/",
    OptiEximC: "https://www.ivldsp.com/products/optieximc/",
    OptiSign: "https://www.ivldsp.com/products/optisign/",
    OptiSignC: "https://www.ivldsp.com/products/optisignc/",
    OptiEinvoice: "https://www.ivldsp.com/products/optie-invoice/",
    OptiEinvoiceC: "https://www.ivldsp.com/products/optie-invoicec/",
    OptiGST: "https://www.ivldsp.com/products/optigst/",
    OptiGSTC: "https://www.ivldsp.com/products/optigstc/",
    OptiGSTReco: "https://www.ivldsp.com/products/optigstreco/",
    OptiVMS: "https://www.ivldsp.com/products/optivms/",
    OptiGulfVAT: "https://www.ivldsp.com/products/optigulfvat/",
    OptiVive: "https://www.ivldsp.com/products/optivive/",
    "OptiTrack.AI": "https://www.ivldsp.com/products/optitrack-ai/",
    OptiEWayBill: "https://www.ivldsp.com/products/optiewaybill/",
    OptiIntelliV: "https://www.ivldsp.com/products/optiintelliv/",
    Proactivate: "https://www.ivldsp.com/products/proactivate/",
    Ideck: "https://www.ivldsp.com/products/ideck/",
    OptiMobility: "https://www.ivldsp.com/products/optimobility/",
    OptiCompliance: "https://www.ivldsp.com/products/opticompliance/",
    OptiLIMS: "https://www.ivldsp.com/products/optilims/",
    XeMarks: "https://www.ivldsp.com/products/xemarks/",
    XeProof: "https://www.ivldsp.com/products/xeproof/",
    XeGency: "https://www.ivldsp.com/products/xegency/",
    OptiVisitor: "https://www.ivldsp.com/products/optivisitor/",
    OptiMedia: "https://www.ivldsp.com/products/optimedia/",
    OptiQueue: "https://www.ivldsp.com/products/optiqueue/",
     // SAP Services
    ApplicationManagement: "https://www.ivldsp.com/services/sap-services/sap-application-management-services/",
    S4HANAImplementation: "https://www.ivldsp.com/services/sap-services/sap-s4hana-implementation-services/",
    SAPConsulting: "https://www.ivldsp.com/services/sap-services/sap-consulting/",
    CustomDevelopment: "https://www.ivldsp.com/services/sap-services/sap-custom-development/",
    BasisSecurity: "https://www.ivldsp.com/services/sap-services/sap-basis-and-security-services/",
    MigrationToCloud: "https://www.ivldsp.com/services/sap-services/migration-to-cloud/",
  
    // Digital Services
    AWSCloudServices: "https://www.ivldsp.com/services/digital-services/aws-cloud-services/",
    PortalDevelopment: "https://www.ivldsp.com/services/digital-services/portal-development/",
    EnterpriseMobilityApps: "https://www.ivldsp.com/services/digital-services/enterprise-mobility-apps/",
    AIMLBlockchain: "https://www.ivldsp.com/services/digital-services/ai-ml-blockchain/",
    AboutCompany: "https://www.ivldsp.com/about-us/",
  
  };
  
  export const productLogo = {
    OptiSuiteC: "https://www.ivldsp.com/wp-content/uploads/2025/09/producst-suite.png",
    OptiSuite: "https://www.ivldsp.com/wp-content/uploads/2023/01/OptiSutie10x.png",
    OptiExim: "https://www.ivldsp.com/wp-content/uploads/2019/06/optiexim-3.png",
    OptiEximC: "https://www.ivldsp.com/wp-content/uploads/2019/09/optieximc-2.jpg",
    OptiSign: "https://www.ivldsp.com/wp-content/uploads/2019/06/optisign.png",
    OptiSignC: "https://www.ivldsp.com/wp-content/uploads/2025/04/optisignc.png",
    OptiEinvoice: "https://www.ivldsp.com/wp-content/uploads/2019/10/E-Invoicing-software-1.png",
    OptiEinvoiceC: "https://www.ivldsp.com/wp-content/uploads/2025/09/producs-e-invoicec.png",
    OptiGST: "https://www.ivldsp.com/wp-content/uploads/2019/06/optigst-2.png",
    OptiGSTC: "https://www.ivldsp.com/wp-content/uploads/2025/09/products-gstc.png",
    OptiGSTReco: "https://www.ivldsp.com/wp-content/uploads/2019/06/gst-reco-small.png",
    OptiVMS: "https://www.ivldsp.com/wp-content/uploads/2021/07/vendor-management-software-1.png",
    OptiGulfVAT: "https://www.ivldsp.com/wp-content/uploads/2019/09/Opti_Gulf_VAT-1.jpg",
    OptiVive: "https://www.ivldsp.com/wp-content/uploads/2020/11/Vendor-invoice-automation.png",
    "OptiTrack.AI": "https://www.ivldsp.com/wp-content/uploads/2024/12/OptiTrack-3.png",
    OptiEWayBill: "https://www.ivldsp.com/wp-content/uploads/2019/06/optie-waybill-1.png",
    OptiIntelliV: "https://www.ivldsp.com/wp-content/uploads/2019/06/opti-intelliv.png",
    Proactivate: "https://www.ivldsp.com/wp-content/uploads/2019/06/proactivate.png",
    Ideck: "https://www.ivldsp.com/wp-content/uploads/2019/02/Ideck.jpg",
    OptiMobility: "https://www.ivldsp.com/wp-content/uploads/2019/06/optimobility.png",
    OptiCompliance: "https://www.ivldsp.com/wp-content/uploads/2019/04/Untitled-2-3.png",
    OptiLIMS: "https://www.ivldsp.com/wp-content/uploads/2019/10/Lab-information-management-system-1.jpg",
    XeMarks: "https://www.ivldsp.com/wp-content/uploads/2019/06/xemarks-home.png",
    XeProof: "https://www.ivldsp.com/wp-content/uploads/2018/06/xeproof.jpg",
    XeGency: "https://www.ivldsp.com/wp-content/uploads/2018/06/xegency.jpg",
    OptiVisitor: "https://www.ivldsp.com/wp-content/uploads/2019/06/OptiVisitor.png",
    OptiMedia: "https://www.ivldsp.com/wp-content/uploads/2019/06/optimedia.png",
    OptiQueue: "https://www.ivldsp.com/wp-content/uploads/2019/05/optiqueue.png",
     // SAP Services
    ApplicationManagement: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    S4HANAImplementation: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    SAPConsulting: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    CustomDevelopment: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    BasisSecurity: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    MigrationToCloud: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
  
    // Digital Services
    AWSCloudServices: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    PortalDevelopment: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    EnterpriseMobilityApps: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    AIMLBlockchain: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
    AboutCompany: "https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png",
  };